<template>
  <b-modal
    :visible="isVisible"
    size="xl"
    hide-footer
    class="price-comparison-modal"
    dialog-class="modal-fullscreen"
    @hidden="closeModal"
  >
    <template #modal-title>
      <div class="d-flex align-items-center">
        <span>{{ $t('yalnzQiymtMqayissiCdvli') }}</span>
        <price-legend class="ml-4" />
      </div>
    </template>

    <div class="table-container">
      <search-filter v-model="searchQuery" />

      <price-comparison-table
        :products="transformedData.products"
        :companies="transformedData.companies"
        :search-query="searchQuery"
        :ranked-offers="rankedOffers"
      />
    </div>

    <export-buttons @export="exportResultsOnlyPrice" />
  </b-modal>
</template>

<script>
import PriceLegend from '@/components/price-comparison/PriceLegend.vue';
import SearchFilter from '@/components/price-comparison/SearchFilter.vue';
import PriceComparisonTable from '@/components/price-comparison/PriceComparisonTable.vue';
import ExportButtons from '@/components/price-comparison/ExportButtons.vue';

export default {
  name: "OnlyPriceComparisonModal",
  components: {
    PriceLegend,
    SearchFilter,
    PriceComparisonTable,
    ExportButtons
  },
  props: {
    visible: Boolean,
    onlyPriceComparisonData: Array,
    exportResultsOnlyPrice: Function,
    rankedOffers: Array
  },
  data() {
    return {
      isVisible: this.visible,
      searchQuery: ''
    };
  },
  computed: {
    // Transform data for the new table structure with products as rows and companies as columns
    transformedData() {
      // Extract unique products
      const products = [];
      const productMap = new Map();

      this.onlyPriceComparisonData.forEach(row => {
        const productName = row["Məhsullar"];
        if (!productMap.has(productName)) {
          productMap.set(productName, products.length);
          products.push({
            name: productName,
            quantity: row.quantity || null
          });
        }
      });

      // Extract companies with their data
      const companies = [];
      const companyMap = new Map();

      this.onlyPriceComparisonData.forEach(row => {
        Object.keys(row.companies || {}).forEach(companyName => {
          if (!companyMap.has(companyName)) {
            const companyIndex = this.rankedOffers.findIndex(offer =>
                offer.requestUser?.company?.name === companyName
            );

            companyMap.set(companyName, companies.length);
            companies.push({
              name: companyName,
              products: Array(products.length).fill(null),
              mainTotal: this.rankedOffers[companyIndex]?.mainTotal || 0,
              alternativeTotal: this.rankedOffers[companyIndex]?.alternativeTotal || 0,
              mainRank: this.rankedOffers[companyIndex]?.mainRank || 0,
              alternativeRank: this.rankedOffers[companyIndex]?.alternativeRank || 0,
              rejected: this.rankedOffers[companyIndex]?.rejected || false
            });
          }
        });
      });

      // Fill in product data for each company
      this.onlyPriceComparisonData.forEach(row => {
        const productName = row["Məhsullar"];
        const productIndex = productMap.get(productName);

        Object.keys(row.companies || {}).forEach(companyName => {
          const companyIndex = companyMap.get(companyName);
          companies[companyIndex].products[productIndex] = {
            main: row.companies[companyName]?.main || {},
            alternative: row.companies[companyName]?.alternative || {},
            noOffer: row.companies[companyName]?.noOffer || false
          };
        });
      });

      return {products, companies};
    }
  },
  watch: {
    visible(newVal) {
      this.isVisible = newVal;
    },
    isVisible(newVal) {
      this.$emit("update:visible", newVal);
    }
  },
  methods: {
    closeModal() {
      this.isVisible = false;
    }
  }
};
</script>

<style>
.price-comparison-modal {
  max-width: 100vw;
  max-height: 85vh;
  width: 100%;
}

.table-container {
  margin-bottom: 20px;
}

.modal-fullscreen {
  max-width: 100% !important;
  margin: 0 !important;
  width: 100% !important;
}

.modal-fullscreen .modal-content {
  border: 0;
  border-radius: 0;
  height: 100vh;
}
</style>
